export default "__VITE_ASSET__Dea9UxXx__"